import { ObservableFromFetch } from "../ObservableFromFetch"

export interface LabCreate {
  AccountId?: number
  ImplementationClientFlag: string
  ImplementationID?: number
  LabAccount: string
  LabCode: string
  Link?: string
}

export interface LabUpload {
  Base64String: string
  CompanyID?: number
  ImplementationClientFlag: string
  ImplementationID?: number
  Link?: string
}

export function LabAccountCreate(params: LabCreate) {
  const requestBody: string = JSON.stringify(params);

  return ObservableFromFetch<string>("FFOrderLaboratory/LaboratoryInsert", requestBody)
}

export function LabAccountUpload(params: LabUpload) {
  const requestBody: string = JSON.stringify(params);

  return ObservableFromFetch<string>("FFOrderLaboratory/UploadLab", requestBody)
}
